<script>
    import { t } from '../core/i18n/language-store';
    import Button from "../components/Button.svelte";
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let cartItemsStore;
    export let orderConfigStore;
    export let cartTotalStore;
    export let deliveryOpenStore;
    export let publishConfigStore;

    function closeHandler() {
        dispatch('close');
    }

    function confirmOrderHandler(items) {
        dispatch('confirmOrder', items);
    }
</script>

<style>
    .cart-order-button {
        display: flex;
        flex-direction: column;
        gap: 36px;
    }
    .notes {
        border-left: 4px solid var(--accent-color);
        padding: .75rem;
        background: var(--accent-color-semi);
    }
    .order-note {
        line-height: 1.35;
        border-radius: 0;
    }
    .order-warning {
        line-height: 1.25;
        border-radius: 0;
        color: var(--secondary-font-color);
    }
    .order-warning .price {
        font-family: PT Mono, sans-serif;
        color: var(--main-font-color);
    }
</style>

{#if (cartItemsStore.length > 0 && orderConfigStore.enabled)}
<div class="cart-order-button">

    {#if (cartTotalStore?.sum < (orderConfigStore.minOrder || 0) ) }
        <div class="order-warning">
            {$t('cartOrder.minOrderMessage')} <span class="price">{orderConfigStore.minOrder} {publishConfigStore.currency}</span>.
        </div>
    {/if}

    {#if (deliveryOpenStore.isOpen === false && deliveryOpenStore.nextOpenDateStr && orderConfigStore.outOfOpenHours !== 'ALLOW')}
        <div class="notes flex-column gap-1">
            {#if (orderConfigStore.outOfOpenHours === 'ALLOW_NOTIFY')}
                <div class="order-note">
                    {$t('cartOrder.deliveryClosedMessage')}
                </div>
            {/if}
            {#if (deliveryOpenStore.waitMinutes <= 60)}
                <div class="order-note">{$t('cartOrder.openInMinutes')} { deliveryOpenStore.waitMinutes } {$t('cartOrder.minutes')}</div>
            {:else}
                <div class="order-note">{$t('cartOrder.openAt')} { deliveryOpenStore.nextOpenDateStr }</div>
            {/if}
        </div>
    {/if}

    <div class="flex-between gap-05">
        <div>
            <Button label="{$t('cart.buttons.returnToMenu')}"
                    type="secondary--alt"
                    disabled="{cartTotalStore?.sum < (orderConfigStore.minOrder || 0) || (deliveryOpenStore.isOpen === false && orderConfigStore.outOfOpenHours === 'NOT_ALLOW')}"
                    on:clicked={() => closeHandler()}>
            </Button>
        </div>
        <div>
            <Button label={$t('cartOrder.placeOrder')}
                    type="secondary"
                    disabled="{cartTotalStore?.sum < (orderConfigStore.minOrder || 0) || (deliveryOpenStore.isOpen === false && orderConfigStore.outOfOpenHours === 'NOT_ALLOW')}"
                    on:clicked={() => confirmOrderHandler(cartItemsStore)}>
            </Button>
        </div>
    </div>
</div>
{/if}
